import React, { useState } from "react";
import { Upload } from "lucide-react";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";
const inputCls = "w-full bg-black border border-[#00ff90]/20 rounded-lg px-3 py-2 text-sm text-white outline-none focus:border-[#00ff90]/50 transition-colors";
const labelCls = "text-xs text-[#00ff90]/50 uppercase tracking-wider block mb-1.5";
const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

export default function TaxDeclaration({ taxRegime, setTaxRegime, investmentDeclaration, setInvestmentDeclaration, investmentProofFile, setInvestmentProofFile, onSubmit }) {
  const [submitting, setSubmitting] = useState(false);
  const [submitted,  setSubmitted]  = useState(false);
  const [error,      setError]      = useState(null);

  const handleSubmit = async () => {
    if (!investmentProofFile) { setError("Please upload proof before submitting."); return; }
    setSubmitting(true);
    setError(null);
    try {
      await onSubmit();
      setSubmitted(true);
      setTimeout(() => setSubmitted(false), 3000);
    } catch (e) {
      setError(e?.message || "Submission failed.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Tax Declaration</span>
      </div>

      <div className="p-5 space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className={labelCls}>Tax Regime</label>
            <select value={taxRegime} onChange={e => setTaxRegime(e.target.value)} className={inputCls}>
              <option value="Old">Old Regime</option>
              <option value="New">New Regime</option>
            </select>
          </div>
          <div className="flex items-end">
            <div className="rounded-lg border border-[#00ff90]/10 bg-[#00ff90]/5 px-4 py-3 text-xs text-white/40 w-full">
              {taxRegime === "New"
                ? "New regime: lower rates, no exemptions/deductions allowed."
                : "Old regime: higher rates but you can claim HRA, 80C, 80D, etc."}
            </div>
          </div>
        </div>

        <div>
          <label className={labelCls}>Investment Declarations</label>
          <textarea value={investmentDeclaration} onChange={e => setInvestmentDeclaration(e.target.value)}
            rows={3} placeholder="e.g. 80C: PPF ₹1,50,000 | 80D: Health Insurance ₹25,000…"
            className={`${inputCls} resize-none placeholder-white/20`} />
        </div>

        <div>
          <label className={labelCls}>Upload Investment Proof</label>
          <div className="border border-dashed border-[#00ff90]/20 rounded-lg px-4 py-3 bg-[#00ff90]/5 flex items-center gap-3">
            <Upload size={16} className="text-[#00ff90]/40 shrink-0" />
            <input type="file" onChange={e => setInvestmentProofFile(e.target.files[0])}
              className="text-sm text-white/50 w-full" />
          </div>
          {investmentProofFile && <p className="text-xs text-white/30 mt-1 truncate">📎 {investmentProofFile.name}</p>}
        </div>

        {error && <p className="text-red-400 text-xs">⚠ {error}</p>}
        {submitted && <p className="text-[#00ff90] text-xs">✓ Declaration submitted successfully.</p>}

        <div className="flex justify-end">
          <button onClick={handleSubmit} disabled={submitting}
            className="text-xs px-5 py-2 rounded-lg bg-[#00ff90]/15 text-[#00ff90] border border-[#00ff90]/30 hover:bg-[#00ff90]/25 disabled:opacity-40 transition-colors font-medium">
            {submitting ? "Submitting…" : "Submit Declaration"}
          </button>
        </div>
      </div>
    </div>
  );
}